(function () {
  // Off-screen slider slides are marked aria-hidden="true", but their links stay
  // reachable with Tab. Take those links out of the tab order while the slide is
  // hidden, and put them back when it becomes visible. Also gives Klaviyo's star
  // rating a role so its aria-label is allowed.
  // Only the elements that change are processed, so autoplaying sliders stay cheap.
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function hide(el) {
    var targets = el.matches(FOCUSABLE) ? [el] : [];
    Array.prototype.push.apply(targets, el.querySelectorAll(FOCUSABLE));
    targets.forEach(function (f) {
      if (f.hasAttribute('data-a11y-tabindex')) return;
      f.setAttribute('data-a11y-tabindex', f.getAttribute('tabindex') || '');
      f.setAttribute('tabindex', '-1');
    });
  }

  function show(el) {
    var targets = el.hasAttribute('data-a11y-tabindex') ? [el] : [];
    Array.prototype.push.apply(targets, el.querySelectorAll('[data-a11y-tabindex]'));
    targets.forEach(function (f) {
      if (f.closest('[aria-hidden="true"]')) return; // still inside another hidden slide
      var original = f.getAttribute('data-a11y-tabindex');
      if (original) f.setAttribute('tabindex', original); else f.removeAttribute('tabindex');
      f.removeAttribute('data-a11y-tabindex');
    });
  }

  function update(el) {
    if (el.getAttribute('aria-hidden') === 'true') hide(el); else show(el);
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.hasAttribute('aria-hidden')) update(root);
    else if (root.parentElement && root.parentElement.closest('[aria-hidden="true"]')) hide(root);
    root.querySelectorAll('[aria-hidden="true"]').forEach(hide);
    // Only the plain-div version needs a role; on product pages Klaviyo renders it as a link, which already allows aria-label.
    var stars = root.matches('div.kl_reviews__star_rating_widget') ? [root] : [];
    Array.prototype.push.apply(stars, root.querySelectorAll('div.kl_reviews__star_rating_widget[aria-label]:not([role])'));
    stars.forEach(function (s) { if (s.hasAttribute('aria-label') && !s.hasAttribute('role')) s.setAttribute('role', 'img'); });
  }

  // A slider can make a hidden slide focusable again after hiding it (slick sets tabindex).
  function retab(el) {
    if (el.getAttribute('tabindex') === '-1' || !el.closest('[aria-hidden="true"]')) return;
    el.setAttribute('data-a11y-tabindex', el.getAttribute('tabindex') || '');
    el.setAttribute('tabindex', '-1');
  }

  new MutationObserver(function (records) {
    records.forEach(function (r) {
      if (r.type === 'childList') r.addedNodes.forEach(scan);
      else if (r.attributeName === 'aria-hidden') update(r.target);
      else retab(r.target);
    });
  }).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document.documentElement); });
  } else {
    scan(document.documentElement);
  }
})();